import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1317Model } from './kymw1317.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { GetApprovalItemListService } from './api-services/get-approval-item-list';
import { ApprovalItemService } from './api-services/approval-item';
import { ApprovalItemListModel } from './vo/kymw1317-approval-item-list.model';
import { ApprovalItemModel } from './vo/kymw1317-approval-item.model';
import { KYMW1317InputModel } from './vo/kymw1317-input.model';
import { KYMW1317OutputModel } from './vo/kymw1317-output.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component'
import { FlexGrid } from '@grapecity/wijmo.grid';

/**
 * 企画連絡承認画面を管理するクラス
 *
 * @export KYMW1317Component
 * @class KYMW1317Component
 */
@Component({
  selector: 'app-kymw1317',
  templateUrl: 'kymw1317.component.html',
  styleUrls: ['kymw1317.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1317Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  setKYMW1317Parameter: Function;

  kymw1317Model: KYMW1317Model = new KYMW1317Model();

  /**
   * Creates an instance of KYMW1317Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1317Component
   */
  constructor(
    public dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getApprovalItemListService: GetApprovalItemListService,
    private approvalItemService: ApprovalItemService
  ) {
    super(kymw00Model);
  }

  @ViewChild('dtg_approvalColumnList') dtg_approvalColumnList: FlexGrid;

  /**
   * 初期処理
   *
   * @return {*}  {Promise<any>}
   * @memberof KYMW1317Component
   */
  public async ngOnInit(): Promise<any> {
    this.componentName = 'KYMW1317';
    const model = this.kymw1317Model;

    // APIパラメータ作成
    const getApprovalItemListVO: ApprovalItemListModel = new ApprovalItemListModel();
    getApprovalItemListVO.orderCode = model.orderCode;
    getApprovalItemListVO.pCode = model.pCode;

    // API取得
    const data = await this.getApprovalItemListForPromise(model, getApprovalItemListVO);
    model.updateKYMW1317(data);

    // 取引先連絡情報リストが１つしかない場合は初期値として選択
    model.selectedItemCode = model.supplierInformationList.length === 1 ? model.supplierInformationList[0].itemCode : '';

    // 生協の数が変更されている場合、メッセージを出す
    if (model.isDisabledCoop) {
      await this.openAlertGetMessageForPromise('E0665');
    }

    // ロック取得失敗時または生協の数が変更されている場合は閲覧モードにする
    if (model.lockInfo === '1' || model.isDisabledCoop) {
      this.setReadOnlyMode();
      return;
    }

    // 編集チェックボックスの活性/非活性制御
    model.isDisabledEditorCheckbox =
      model.kikakuRenrakuStatus === '4'
      || model.kikakuRenrakuStatus === '6'
      || model.kikakuRenrakuStatus === '7'
      || model.kikakuRenrakuStatus === '11'
      || model.kikakuRenrakuStatus === '13'
      || model.kikakuRenrakuStatus === '14';
    // バイヤーチェックボックスの活性/非活性制御
    model.isDisabledBuyerCheckbox =
      model.kikakuRenrakuStatus === '5'
      || model.kikakuRenrakuStatus === '6'
      || model.kikakuRenrakuStatus === '7'
      || model.kikakuRenrakuStatus === '12'
      || model.kikakuRenrakuStatus === '13'
      || model.kikakuRenrakuStatus === '14';
    // 編集チェックボックスの初期値設定
    model.editorCheckboxVal = model.kikakuRenrakuStatus === '4' || model.kikakuRenrakuStatus === '11';
    // バイヤーチェックボックスの初期値設定
    model.buyerCheckboxVal = model.kikakuRenrakuStatus === '5' || model.kikakuRenrakuStatus === '12';

    this.dtg_approvalColumnList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_approvalColumnList.hitTest(e);
      if (0 <= ht.row && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        switch (ht.col) {
          case 7:
            document.getElementById(`reflect_${ht.row}`).click();
            break;
          case 8:
            document.getElementById(`skewer_${ht.row}`).click();
            break;
        }
      }
    });
  }

  /**
   * 反映チェックボックス changeイベント
   *
   * @param {EventTarget} target
   * @param {*} selectRow
   * @return {*}  {Promise<any>}
   * @memberof KYMW1317Component
   */
  public async changeReflectCheckbox(target: EventTarget, selectRow: any): Promise<any> {
    if ((target as HTMLInputElement).checked) {

      // 同一項目チェック
      if (selectRow.reflectUnit === 'P') {
        const sameReflectColumn = this.kymw1317Model.approvalColumnList.find(col =>
          selectRow.columnNo === col.columnNo
          && selectRow.itemCode !== col.itemCode
          && col.isReflect
        )
        // 同一項目が存在する場合警告表示
        if (sameReflectColumn) {
          await this.openAlertGetMessageForPromise('E0270', [sameReflectColumn.itemCode]);
          selectRow.isReflect = false;
          return;
        }
      }

      // NGワードチェック
      if (selectRow.ngWord !== '' && selectRow.ngWord !== null) {
        this.openAlertGetMessageForPromise('I0105', [selectRow.columnName, selectRow.ngWord]);
      }

      // 串刺チェック活性/非活性制御
      selectRow.isDisabledSkewer = selectRow.skeweredConfig !== '0'
        && selectRow.skeweredConfig !== '2'
        && selectRow.skeweredConfig !== '3';

    } else {
      // 串刺チェックを外す
      selectRow.isSkewer = false;
      // 串刺チェックを非活性
      selectRow.isDisabledSkewer = true;
    }
  }

  /**
   * バイヤー/編集チェックボックス changeイベント
   *
   * @param {EventTarget} target
   * @param {string} approvalType
   * @memberof KYMW1317Component
   */
  public changeApprovalTypeCheckbox(target: EventTarget, approvalType: string): void {
    const model = this.kymw1317Model;
    if ((target as HTMLInputElement).checked) {
      model.isDisabledApprovalButton = false;
    } else {
      if (approvalType === 'buyer') {
        model.isDisabledApprovalButton = !model.editorCheckboxVal || model.isDisabledEditorCheckbox;
      }
      if (approvalType === 'editor') {
        model.isDisabledApprovalButton = !model.buyerCheckboxVal || model.isDisabledBuyerCheckbox;
      }
    }
  }

  /**
   * 承認ボタン clickイベント
   *
   * @return {*}  {Promise<any>}
   * @memberof KYMW1317Component
   */
  public async clickApprovalButton(): Promise<any> {
    const model = this.kymw1317Model;

    // アイテムコードが選択されていない場合エラー表示
    if (!model.selectedItemCode) {
      this.openAlertGetMessageForPromise('E0271');
      return;
    }

    const approvalList = model.approvalColumnList.filter(col => col.isReflect);


    // 串刺必須項目で串刺設定されていない場合エラー表示
    const errorCol = approvalList.find(col => !col.isSkewer && col.skeweredConfig === '3');
    if (errorCol) {
      this.openAlertGetMessageForPromise('E0272', [errorCol.itemCode, errorCol.columnName]);
      return;
    }

    // 串刺優先項目で串刺設定されていない場合警告表示
    for (const col of approvalList) {
      if (!col.isSkewer && col.skeweredConfig === '2') {
        const closeDetail = await this.openAlertGetMessageForPromise('Q0158', [col.itemCode, col.columnName])
        if (closeDetail === PlessAlert.No) return;
      }
    }

    // 編集権限でバイヤー項目を承認する場合、バイヤー権限で編集項目を承認する場合、警告表示
    const approvalType =
      model.buyerCheckboxVal && !model.editorCheckboxVal ? 1
        : !model.buyerCheckboxVal && model.editorCheckboxVal ? 2
          : 0;
    if (approvalType === 1 || approvalType === 2) {
      for (const col of approvalList) {
        if ((approvalType === 1 && col.approver === '編集')
          || (approvalType === 2 && col.approver === 'バイヤー')) {
          const closeDetail = await this.openAlertGetMessageForPromise(
            'Q0157',
            [approvalType === 1 ? 'バイヤー' : '編集', approvalType === 1 ? '編集' : 'バイヤー']);
          if (closeDetail === PlessAlert.No) return;
        }
      }
    }

    // APIリクエスト生成
    const approvalItemModel: ApprovalItemModel = new ApprovalItemModel();
    approvalItemModel.orderCode = model.orderCode;
    approvalItemModel.pCode = model.pCode;
    approvalItemModel.editorSelect = model.editorCheckboxVal ? '1' : '0';
    approvalItemModel.buyerSelect = model.buyerCheckboxVal ? '1' : '0';
    approvalItemModel.coopInformation = model.supplierInformationList;
    approvalItemModel.approvalColumnList = approvalList.map((col) => {
      return {
        ...col,
        skewerSelect: col.isSkewer ? '1' : '0'
      };
    });
    // API呼び出し
    const result = await this.approvalItemForPromise(model, approvalItemModel);
    if (result.MessageID) {
      await this.openAlertGetMessageForPromise(result.MessageID, [result.Parameter1]);
    }
    // 前画面に戻る
    this.closeWindow(true);
  }

  /**
   * 戻るボタン clickイベント
   *
   * @memberof KYMW1317Component
   */
  public clickBackButton(): void {
    this.closeWindow(false);
  }

  /**
   *
   *
   * @param {*}this.inputVo
   * @memberof KYMW1317Component
   */
  public setInterfaceParam(inputVO: KYMW1317InputModel) {
    const model = this.kymw1317Model
    // 受渡情報より権限を取得
    model.permission = inputVO.UserPermission;
    // 受渡情報より受注コードを取得
    model.orderCode = inputVO.orderCode;
    // 受渡情報よりＰコードリストを取得
    model.pCode = inputVO.pCodeList[0];
    // 受渡情報よりロック情報を取得?
    model.lockInfo = inputVO.lockInfo;
  }

  /**
   * 画面を閲覧モードに設定する
   *
   * @private
   * @memberof KYMW1317Component
   */
  private setReadOnlyMode(): void {
    const model = this.kymw1317Model;
    model.isDisabledMessageFromCoop = true;
    model.isDisabledBuyerCheckbox = true;
    model.isDisabledEditorCheckbox = true;
    model.approvalColumnList.forEach(column => column.isDisabledReflect = true);
  }

  /**
   * 現在選択されている取引先情報を取得する
   *
   * @param {string} key
   * @return {*}  {*}
   * @memberof KYMW1317Component
   */
  public getSelectedSupplierInformation(key: string): any {
    const selectedSupplierInformation: any = this.kymw1317Model.supplierInformationList.find(si => si.itemCode == this.kymw1317Model.selectedItemCode);
    return selectedSupplierInformation ? selectedSupplierInformation : { [key]: '' };
  }

  /**
   * アラートを表示する
   *
   * @private
   * @param {string} msgId
   * @param {Array<string>} [replaceStr]
   * @return {*}  {Promise<PlessAlert>}
   * @memberof KYMW1317Component
   */
  private openAlertGetMessageForPromise(msgId: string, replaceStr?: Array<string>): Promise<PlessAlert> {
    return new Promise((rs) => {
      this.dialogServiceSub.openAlertGetMessage(
        msgId,
        replaceStr,
        (closeDetail) => rs(closeDetail)
      );
    });
  }

  /**
   * 初期表示API
   *
   * @private
   * @param {KYMW1317Model} model
   * @param {ApprovalItemListModel} vo
   * @return {*}  {Promise<any>}
   * @memberof KYMW1317Component
   */
  private getApprovalItemListForPromise(model: KYMW1317Model, vo: ApprovalItemListModel): Promise<any> {
    const service = this.getApprovalItemListService;
    return new Promise((rs) => {
      service.execute(model, vo, data => rs(data));
    });
  }

  /**
   * 承認API
   *
   * @private
   * @param {KYMW1317Model} model
   * @param {ApprovalItemModel} vo
   * @return {*}  {Promise<any>}
   * @memberof KYMW1317Component
   */
  private approvalItemForPromise(model: KYMW1317Model, vo: ApprovalItemModel): Promise<any> {
    const service = this.approvalItemService;
    return new Promise((rs) => {
      service.execute(model, vo, data => rs(data));
    });
  }

  /**
   * 閉じる処理を行う
   *
   * @private
   * @param {boolean} isExecuteApproval
   * @memberof KYMW1317Component
   */
  private closeWindow(isExecuteApproval: boolean): void {
    const outputVO: KYMW1317OutputModel = new KYMW1317OutputModel();
    outputVO.isExecuteApproval = isExecuteApproval;
    this.setKYMW1317Parameter(outputVO);
    this.closeFunction();
  }

  /**
   *日付型をyyyy/MM/ddの文字列に変換
   *
   * @public
   * @param {string} dt
   * @returns {string}
   * @memberof KYMW1317Component
   */
  public convertDateToYYYYMMDDString(dt: string): string {
    if (dt == null) {
      return '';
    }
    if (dt.trim().length < 8) {
      return dt;
    }

    const y = dt.substr(0, 4);
    const m = dt.substr(4, 2);
    const d = dt.substr(6, 2);
    return y + '/' + m + '/' + d;
  }
}
